var React = require('react');

function SliderNextArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 13.8191L14 20.4857L10 27.1524","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

SliderNextArrow.defaultProps = {"width":"24","height":"41","viewBox":"0 0 24 41","fill":"none"};

module.exports = SliderNextArrow;

SliderNextArrow.default = SliderNextArrow;
